import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import StbReturn from "../components/stbreturn.jsx";
import Footer from "../components/footer.jsx";

function StbReturnpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <StbReturn/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default StbReturnpage;
